var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 35,
    viewBox: "0 0 163 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 24,
    width: 13,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.318 34.0632L21.5029 34.0529L15.7592 34.0632L21.5335 24.0234L27.318 34.0632Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_1912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 23,
    width: 13,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3385 23.8184H15.5855V34.063H27.3385V23.8184Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.428 18.9009H10.6492V39.1852H32.428V18.9009Z",
    fill: "#5D5A5B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 19,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4398 17.0266L29.5153 23.8392L15.7592 0L23.6184 0.0102449L33.4398 17.0266Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3_1912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 19,
    height: 25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4705 0H15.5855V24.0749H33.4705V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5498 -5.12207H10.6492V28.9618H38.5498V-5.12207Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 24,
    width: 13,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.067 34.0632L37.2519 34.0529L31.5082 34.0632L37.2927 24.0234L43.067 34.0632Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3_1912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 23,
    width: 13,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1794 23.8184H31.4265V34.063H43.1794V23.8184Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.177 18.9009H26.3982V39.1852H48.177V18.9009Z",
    fill: "#5D5A5B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 35
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81119 17.0266L0 0H7.87961L17.6806 17.0266L7.87961 34.0634H0L9.81119 17.0266Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3_1912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 35
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.885 0H0V34.0634H17.885V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7906 -5.12207H-5.10999V39.1859H22.7906V-5.12207Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 0,
    width: 28,
    height: 35
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1204 34.0634H59L49.1888 17.0266L39.3878 0H31.5082L41.3194 17.0266L51.1204 34.0634Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3_1912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 0,
    width: 29,
    height: 35
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0204 0H31.4265V34.0634H59.0204V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.11 -5.12207H26.3982V39.1859H64.11V-5.12207Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 0,
    width: 94,
    height: 22
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.475 18.2152H158.344C158.837 18.2152 159.251 18.0357 159.598 17.6767C159.933 17.3177 160.101 16.9026 160.101 16.4202V5.69504C160.101 5.21263 159.933 4.78632 159.586 4.43854C159.24 4.09075 158.825 3.91125 158.344 3.91125H156.475V18.204V18.2152ZM163 16.1958C163 17.5533 162.53 18.7088 161.579 19.6736C160.627 20.6385 159.497 21.1209 158.165 21.1209H153.33V0.534399H158.165C159.508 0.534399 160.65 1.0168 161.59 1.98162C162.53 2.94644 163 4.10197 163 5.44823V16.207V16.1958ZM143.347 0.523178L147.522 14.3559V0.523178H150.678V21.1097H147.298L142.955 7.92758V21.1097H139.811V0.523178H143.358H143.347ZM137.147 21.1097H134.002V0.523178H137.147V21.1097ZM119.721 21.1097H116.61V0.523178H121.087L123.997 15.2871L126.795 0.523178H131.103V21.1097H127.981V8.17439L125.272 21.1097H122.754L119.721 8.20805V21.1097ZM114.674 21.1097H106.213V0.523178H109.302V18.0357H114.663V21.1209L114.674 21.1097ZM99.9342 4.97704C99.9342 4.47219 99.7663 4.04588 99.4417 3.6981C99.1172 3.35031 98.7143 3.18203 98.2442 3.18203C97.7741 3.18203 97.3824 3.35031 97.0467 3.6981C96.7109 4.04588 96.543 4.47219 96.543 4.97704V16.409C96.543 16.9026 96.7109 17.3289 97.0467 17.6767C97.3824 18.0245 97.7741 18.204 98.2442 18.204C98.7143 18.204 99.1172 18.0245 99.4417 17.6767C99.7663 17.3289 99.9342 16.9026 99.9342 16.409V4.97704ZM98.7143 0.276367C100.057 0.276367 101.21 0.758772 102.15 1.72359C103.09 2.6884 103.56 3.84394 103.56 5.21263V16.4314C103.56 17.8001 103.09 18.9669 102.139 19.9205C101.188 20.8741 100.046 21.3565 98.7143 21.3565C97.3824 21.3565 96.2409 20.8741 95.3008 19.9092C94.3606 18.9444 93.9018 17.7889 93.9018 16.4202V5.20141C93.9018 3.83272 94.3718 2.66597 95.3231 1.71237C96.2744 0.758774 97.4048 0.276367 98.7143 0.276367ZM87.612 4.97704C87.612 4.47219 87.4441 4.04588 87.1195 3.6981C86.795 3.35031 86.3921 3.18203 85.922 3.18203C85.452 3.18203 85.0602 3.35031 84.7245 3.6981C84.3887 4.04588 84.2209 4.47219 84.2209 4.97704V16.409C84.2209 16.9026 84.3887 17.3289 84.7245 17.6767C85.0602 18.0245 85.452 18.204 85.922 18.204C86.3921 18.204 86.795 18.0245 87.1195 17.6767C87.4441 17.3289 87.612 16.9026 87.612 16.409V4.97704ZM85.8996 0.276367C87.2426 0.276367 88.3954 0.758772 89.3355 1.72359C90.2756 2.6884 90.7457 3.84394 90.7457 5.21263V16.4314C90.7457 17.8001 90.2756 18.9669 89.3243 19.9205C88.373 20.8741 87.2315 21.3565 85.8996 21.3565C84.5678 21.3565 83.4262 20.8741 82.4861 19.9092C81.546 18.9444 81.0872 17.7889 81.0872 16.4202V5.20141C81.0872 3.83272 81.5572 2.66597 82.5085 1.71237C83.4598 0.758774 84.5902 0.276367 85.8996 0.276367ZM72.1001 14.6028V21.1097H69V0.523178H72.1001V7.86027L75.8494 0.523178H79.151L74.9317 8.94849L79.8784 21.1209H76.2523L73.0179 12.7741L72.1113 14.614L72.1001 14.6028Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3_1912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 0,
    width: 96,
    height: 22
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163 0.287598H68.989V21.6033H163V0.287598Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.596 -5.32129H63.3929V26.9776H168.596V-5.32129Z",
    fill: "#1886CD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 27,
    width: 66,
    height: 7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.38 30.1404H146.761C147.04 30.1404 147.231 30.0058 147.331 29.7253C147.365 29.6244 147.387 29.4897 147.387 29.3439C147.387 29.0971 147.331 28.9064 147.208 28.7717C147.096 28.6483 146.951 28.5922 146.772 28.5922H146.391V30.1404H146.38ZM146.38 32.8105H146.761C147.074 32.8105 147.287 32.6534 147.399 32.3281C147.443 32.2159 147.466 32.0925 147.466 31.9579C147.466 31.6213 147.399 31.3745 147.276 31.2174C147.164 31.0716 146.996 31.0043 146.772 31.0043H146.391V32.8105H146.38ZM145.406 33.708V27.6723H146.761C147.119 27.6723 147.443 27.762 147.734 27.9528C147.981 28.1098 148.16 28.3679 148.26 28.6932C148.316 28.8727 148.35 29.0859 148.35 29.3327C148.35 29.7365 148.238 30.0619 148.025 30.3087C147.936 30.4097 147.824 30.4882 147.712 30.5443C147.913 30.6228 148.081 30.7687 148.227 31.0043C148.316 31.1613 148.395 31.3521 148.439 31.5989C148.462 31.7223 148.473 31.8681 148.473 32.014C148.473 32.3954 148.406 32.7207 148.26 32.99C148.148 33.2031 147.992 33.3602 147.779 33.4948C147.544 33.6407 147.32 33.708 147.096 33.708H145.418H145.406ZM139.005 29.0522L138.669 31.4306H139.341L139.005 29.0522ZM138.524 32.3169L138.3 33.708H137.36L138.378 27.6723H139.632L140.639 33.708H139.687L139.475 32.3169H138.524ZM132.592 33.708H130.118V27.6723H131.025V32.8105H132.592V33.7192V33.708ZM124.232 29.0185C124.232 28.8727 124.187 28.7493 124.086 28.6483C123.985 28.5473 123.862 28.5025 123.717 28.5025C123.571 28.5025 123.448 28.5473 123.347 28.6483C123.247 28.7493 123.191 28.8727 123.191 29.0185V32.3281C123.191 32.4739 123.247 32.5973 123.347 32.6983C123.448 32.7993 123.571 32.8554 123.717 32.8554C123.862 32.8554 123.985 32.7993 124.086 32.6983C124.187 32.5973 124.232 32.4739 124.232 32.3281V29.0185ZM123.739 27.5938C124.142 27.5938 124.478 27.7396 124.758 28.0201C125.037 28.3005 125.183 28.6483 125.183 29.041V32.3393C125.183 32.7432 125.037 33.0797 124.758 33.3602C124.478 33.6407 124.131 33.7865 123.739 33.7865C123.347 33.7865 123 33.6407 122.721 33.3602C122.441 33.0797 122.307 32.732 122.307 32.3393V29.041C122.307 28.6371 122.452 28.3005 122.732 28.0201C123.012 27.7396 123.347 27.5938 123.739 27.5938ZM115.256 27.6611L116.453 31.7223V27.6611H117.36V33.6968H116.386L115.133 29.8263V33.6968H114.226V27.6611H115.245H115.256ZM107.287 31.1501V33.708H106.381V27.6723H107.287V30.2414H108.373V27.6723H109.279V33.708H108.373V31.1501H107.287ZM100.057 33.7865C99.6544 33.7865 99.3186 33.6407 99.0388 33.3714C98.759 33.091 98.6247 32.7544 98.6247 32.3505V29.041C98.6247 28.6371 98.7702 28.3005 99.05 28.0201C99.3298 27.7396 99.6656 27.5938 100.068 27.5938C100.471 27.5938 100.807 27.7396 101.087 28.0201C101.367 28.3005 101.501 28.6483 101.501 29.041V29.7253H100.561V29.0185C100.561 28.8727 100.505 28.7493 100.404 28.6483C100.303 28.5473 100.18 28.4913 100.035 28.4913C99.8894 28.4913 99.7663 28.5473 99.6656 28.6483C99.5648 28.7493 99.5089 28.8727 99.5089 29.0185V32.3393C99.5089 32.4851 99.5648 32.6086 99.6656 32.7095C99.7663 32.8105 99.8894 32.8666 100.035 32.8666C100.18 32.8666 100.303 32.8105 100.404 32.7095C100.505 32.6086 100.561 32.4851 100.561 32.3393V31.5091H101.501V32.3505C101.501 32.7544 101.356 33.091 101.076 33.3714C100.796 33.6519 100.46 33.7865 100.057 33.7865ZM91.2717 33.708V27.6723H93.857V28.581H92.1782V30.2302H93.4093V31.1389H92.1782V32.7881H93.857V33.6968H91.2717V33.708ZM84.5342 28.581H83.5717V27.6723H86.4033V28.581H85.4408V33.708H84.5342V28.581Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3_1912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_3_1912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 27,
    width: 66,
    height: 7
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.73 27.4927H83.5382V33.9435H148.73V27.4927Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_3_1912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.058 21.9956H77.9647V39.4072H154.058V21.9956Z",
    fill: "#5D5A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.034326c69672eb88a5d415ebae80a6a5.svg";
export { ForwardRef as ReactComponent };